import { createApiClient } from '@/lib/apiClient'

import type { GetActivitiesforUserCsvApiService } from './services/getActivitiesForUserCsv'
import createGetActivitiesForUserCsvApiService from './services/getActivitiesForUserCsv'
import type { GetCompletedActivitiesforUserCsvApiService } from './services/getCompletedActivitiesForUserCsv'
import createGetCompletedActivitiesForUserCsvApiService from './services/getCompletedActivitiesForUserCsv'

interface AgentApiService {
  getActivitiesForUserCsv: GetActivitiesforUserCsvApiService
  getCompletedActivitiesForUserCsv: GetCompletedActivitiesforUserCsvApiService
}

const createAgentApiService = (token: string, accessKey: string): AgentApiService => {
  const apiClient = createApiClient('Agent', {
    baseURL: `${import.meta.env.VITE_VOUCH_API}/`,
    headers: {
      'Ocp-Apim-Subscription-Key': accessKey,
      Authorization: `Bearer ${token}`,
    },
  })

  return {
    getActivitiesForUserCsv: createGetActivitiesForUserCsvApiService(apiClient),
    getCompletedActivitiesForUserCsv:
      createGetCompletedActivitiesForUserCsvApiService(apiClient),
  }
}

export default createAgentApiService
